/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CertRosetteAltIcon16Solid = forwardRef('CertRosetteAltIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 .625A5.375 5.375 0 0 0 4 9.59v5.276a1.1 1.1 0 0 0 1.738.896L8 14.15l2.262 1.611A1.1 1.1 0 0 0 12 14.867V9.59A5.375 5.375 0 0 0 8 .625ZM4.625 6a3.375 3.375 0 1 1 6.75 0 3.375 3.375 0 0 1-6.75 0Z" })));
});
